<div class="cart-item__product-wrap">
  <h3 class="cart-item__product-name">{{product.title}} <span *ngIf="productType == productTypes.Credential && isExpired()" style="color: red;"> - Expired Credentials</span>
    {{productType === productTypes.Exam ? "(" + product.code + ")" : ""}}</h3>
  <div class="data-list  cart-item__product-details">
    <div *ngIf="productType === productTypes.OtherProduct && product.initials" class="data-item data-item--inline ">
      <div class="data-item__label label">Initials</div>
      <div class="data-item__value">{{product.initials}}</div>
    </div>
    <div class="data-item" *ngIf="productType === productTypes.Credential">
      <div class="data-item__label label">Send To:</div>
      <div *ngIf="!product.sendTo.email" class="data-item__value">
        <div>{{product.sendTo.name}}</div>
        <div>{{product.sendTo.line1}}</div>
        <div>{{product.sendTo.line2}}</div>
        <div>{{product.sendTo.line3}}</div>
        <div *ngIf="product.sendTo.postalCode && product.sendTo.state">{{product.sendTo.city}}, {{product.sendTo.state}} {{product.sendTo.postalCode}}</div>
        <div>{{product.sendTo.countryName}}</div>
      </div>
      <div *ngIf="product.sendTo.email" class="data-item__value">
        <div>Email: {{product.sendTo.email}}</div>
      </div>
    </div>
  </div>
  <button *ngIf="canRemove" class="button button--icon button--bare cart-item__remove-button" (click)="onRemove()">
    <i class="button__icon icon icon--trash"></i>
    <span class="button__text">Remove</span>
  </button>
</div>
<div class="cart-item-data">
  <span class="cart-item-data__label">Unit Price:</span>
  <span class="cart-item-data__value">${{effectivePrice | number : '1.2-2'}}</span>
  <span class="cart-item-data__value strikethrough-disable" *ngIf="basePrice > 0 && basePrice != effectivePrice">${{basePrice | number : '1.2-2'}}</span>
</div>
<div class="cart-item-data cart-item-data--qty">
  <span class="cart-item-data__label">Qty:</span>
  <span class="cart-item-data__value">{{product.quantity}}</span>
</div>
<div class="cart-item-data">
  <span class="cart-item-data__label">Total Price:</span>
  <span class="cart-item-data__value">${{(effectivePrice ? effectivePrice : basePrice) * (product.quantity || 0) | number : '1.2-2'}}</span>
</div>
 